import { useEffect, useState, useCallback } from "react";
import ModalShell from "@/components/ModalShell";
import { AlertTriangle } from "lucide-react";

const bus = new EventTarget();
let resolver = null;

export function confirmDialog(opts = {}) {
  return new Promise((resolve) => {
    resolver = resolve;
    bus.dispatchEvent(new CustomEvent("open", { detail: opts }));
  });
}

export default function ConfirmDialog() {
  const [open, setOpen] = useState(false);
  const [opts, setOpts] = useState({});

  useEffect(() => {
    function onOpen(e) {
      setOpts(e.detail || {});
      setOpen(true);
    }
    bus.addEventListener("open", onOpen);
    return () => bus.removeEventListener("open", onOpen);
  }, []);

  const close = useCallback((result) => {
    setOpen(false);
    if (resolver) {
      const r = resolver;
      resolver = null;
      r(result);
    }
  }, []);

  const destructive = opts.destructive !== false;

  return (
    <ModalShell open={open} onClose={() => close(false)} maxWidth="max-w-md" testId="confirm-dialog">
      <div className="flex gap-4">
        <div
          className="shrink-0 w-10 h-10 rounded-full flex items-center justify-center"
          style={{ background: destructive ? "#E15C2C" : "#FBC90C" }}
        >
          <AlertTriangle className="h-5 w-5" style={{ color: destructive ? "#fff" : "#000" }} />
        </div>
        <div className="flex-1">
          <h2 className="font-display text-2xl uppercase font-bold tracking-tight">
            {opts.title || "Are you sure?"}
          </h2>
          {opts.description && (
            <p className="text-sm text-muted-foreground mt-2">{opts.description}</p>
          )}
        </div>
      </div>

      <div className="flex gap-2 justify-end mt-6">
        <button
          type="button"
          onClick={() => close(false)}
          className="border border-border px-4 py-2 text-xs font-mono uppercase tracking-widest hover:bg-surface-elev"
          data-testid="confirm-cancel"
        >
          {opts.cancelLabel || "Cancel"}
        </button>
        <button
          type="button"
          onClick={() => close(true)}
          className="px-4 py-2 text-xs font-semibold tracking-widest uppercase text-white"
          style={{ background: destructive ? "#E15C2C" : "#050505" }}
          data-testid="confirm-ok"
        >
          {opts.confirmLabel || (destructive ? "Delete" : "Confirm")}
        </button>
      </div>
    </ModalShell>
  );
}
